"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDataToTable = void 0;
var _tsUtils = require("@ori/ts-utils");
var _utils = require("../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const mapDataToTable = (table)=>{
    const { columnDefinitions, rows } = table;
    if (!(0, _tsUtils.isNonNullable)(rows) || !(0, _tsUtils.isNonNullable)(columnDefinitions)) {
        return {
            columns: [],
            data: []
        };
    }
    const columns = columnDefinitions.filter((col)=>(0, _tsUtils.isNonNullable)(col)).map((col)=>{
        var _col_key, _col_label;
        return {
            accessorKey: (_col_key = col.key) !== null && _col_key !== void 0 ? _col_key : '',
            header: (_col_label = col.label) !== null && _col_label !== void 0 ? _col_label : '',
            Cell: (param)=>{
                let { row } = param;
                const { key } = col;
                if (!key) {
                    return '–';
                }
                const value = row[key];
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Html, {
                    isOverflowVisible: false,
                    maxLines: _constants.CELL_MAX_LINES,
                    html: value != null ? String(value) : '-'
                });
            }
        };
    });
    const data = rows.filter(_tsUtils.isNonNullable).map((row)=>{
        var _row_cells;
        const record = {};
        (_row_cells = row.cells) === null || _row_cells === void 0 ? void 0 : _row_cells.forEach((cell)=>{
            if ((0, _tsUtils.isNonNullable)(cell) && cell.columnKey) {
                record[cell.columnKey] = (0, _utils.transformHtmlContent)(cell.value);
            }
        });
        return record;
    });
    return {
        columns,
        data
    };
};
exports.mapDataToTable = mapDataToTable;
